/**
 * Brand collection — hero + card reveal animations.
 * Re-syncs visibility after client pagination, filters, and AJAX section replace.
 */
(function () {
  var refreshTimer = null;
  var cardObserver = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isBrandPage() {
    return document.body.classList.contains('body-template-collection-brand');
  }

  function revealHero(hero) {
    if (!hero) return;
    requestAnimationFrame(function () {
      hero.classList.add('is-ready');
    });
  }

  function isDisplayed(el) {
    return !!(el && el.style.display !== 'none');
  }

  function revealChrome() {
    document.querySelectorAll(
      'body.body-template-collection-brand .cap-filter-bar, body.body-template-collection-brand .cap-brand-grid'
    ).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function revealDisplayedCards(animate) {
    var cards = document.querySelectorAll('body.body-template-collection-brand .cap-card-wrapper');
    var visibleIndex = 0;

    cards.forEach(function (el) {
      if (!isDisplayed(el)) {
        el.classList.remove('is-visible');
        return;
      }
      if (animate && !prefersReducedMotion()) {
        el.style.setProperty('--bh-card-delay', ((visibleIndex % 10) * 0.04) + 's');
        el.classList.remove('is-visible');
      }
      visibleIndex += 1;
    });

    requestAnimationFrame(function () {
      cards.forEach(function (el) {
        if (isDisplayed(el)) el.classList.add('is-visible');
      });
    });
  }

  function observeFirstPaintCards() {
    var cards = document.querySelectorAll('body.body-template-collection-brand .cap-card-wrapper');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      revealDisplayedCards(false);
      return;
    }

    if (cardObserver) cardObserver.disconnect();

    cardObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          cardObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -2% 0px' }
    );

    var visibleIndex = 0;
    cards.forEach(function (el) {
      if (!isDisplayed(el)) return;
      if (el.classList.contains('is-visible')) return;
      el.style.setProperty('--bh-card-delay', ((visibleIndex % 10) * 0.05) + 's');
      visibleIndex += 1;
      cardObserver.observe(el);
    });
  }

  function refreshUi(options) {
    if (!isBrandPage()) return;
    var opts = options || {};
    revealChrome();
    if (opts.firstPaint) {
      observeFirstPaintCards();
    } else {
      revealDisplayedCards(opts.animate !== false);
    }
  }

  function scheduleRefresh(options) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshUi(options);
    }, 40);
  }

  function isFilterControl(el) {
    if (!el || !el.closest) return false;
    return !!(
      el.closest('[data-filter-form]') ||
      el.closest('.cap-pagination') ||
      el.matches('.cap-intensity-radio, [data-price-slider], [data-sort-select], [data-category-select], [data-compatibility-select], [data-vendor-select]')
    );
  }

  function initHomeAjaxAddToCart() {
    document.querySelectorAll('[data-home-brand-cards], [data-brand-style-cards]').forEach(function (section) {
      if (section.dataset.capAjaxBound === '1') return;
      section.dataset.capAjaxBound = '1';

      var forms = section.querySelectorAll('[data-ajax-add-to-cart-form="true"]');
      var toastEl = section.querySelector('.cap-toast');

      forms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
          if (form.dataset.ajaxAddToCartForm !== 'true') return;
          e.preventDefault();
          e.stopPropagation();

          var submitBtn = form.querySelector('button[type="submit"]');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-disabled', 'true');
          }

          var formData = new FormData(form);
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            formData.append('sections', 'cart-drawer,cart-icon-bubble');
            formData.append('sections_url', window.location.pathname);
          }

          fetch(
            typeof window.routes !== 'undefined' && window.routes.cart_add_url
              ? window.routes.cart_add_url
              : '/cart/add.js',
            {
              method: 'POST',
              body: formData,
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }
          )
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              if (data.status && data.status !== 200) {
                if (toastEl) {
                  toastEl.textContent = data.description || 'Грешка при добавяне';
                  toastEl.hidden = false;
                  setTimeout(function () {
                    toastEl.hidden = true;
                  }, 4000);
                }
                return;
              }

              if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(data);
              } else if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else if (toastEl) {
                toastEl.textContent = 'Добавено в количката';
                toastEl.hidden = false;
                setTimeout(function () {
                  toastEl.hidden = true;
                }, 3000);
              }

              if (typeof document.dispatchEvent === 'function') {
                document.dispatchEvent(new CustomEvent('cart:change'));
              }
            })
            .catch(function () {
              if (toastEl) {
                toastEl.textContent = 'Грешка при добавяне';
                toastEl.hidden = false;
                setTimeout(function () {
                  toastEl.hidden = true;
                }, 4000);
              }
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-disabled');
              }
            });
        });
      });
    });
  }

  function init() {
    if (isBrandPage()) {
      var hero = document.querySelector('[data-brand-hero]');
      if (hero) {
        if (prefersReducedMotion()) hero.classList.add('is-ready');
        else revealHero(hero);
      }

      revealChrome();
      requestAnimationFrame(function () {
        refreshUi({ firstPaint: true });
      });

      document.addEventListener('click', function (event) {
        if (!isBrandPage()) return;
        var pagelink = event.target.closest('.cap-pagination a, .cap-pagination__link');
        if (pagelink) {
          scheduleRefresh({ animate: true });
          return;
        }
        var filterOpt = event.target.closest('.cap-dropdown-option, .cap-intensity-pill, [data-clear-filters]');
        if (filterOpt) scheduleRefresh({ animate: true });
      });

      document.addEventListener('change', function (event) {
        if (!isBrandPage()) return;
        if (isFilterControl(event.target)) scheduleRefresh({ animate: true });
      });

      window.addEventListener('popstate', function () {
        if (!isBrandPage()) return;
        scheduleRefresh({ animate: true });
      });

      var root = document.getElementById('MainContent') || document.body;
      if ('MutationObserver' in window && root) {
        var mo = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var nodes = mutations[i].addedNodes;
            for (var j = 0; j < nodes.length; j++) {
              var node = nodes[j];
              if (node.nodeType !== 1) continue;
              if (
                (node.classList && (
                  node.classList.contains('custom-all-products') ||
                  node.classList.contains('cap-card-wrapper') ||
                  node.classList.contains('cap-filter-bar') ||
                  node.classList.contains('cap-product-grid')
                )) ||
                (node.querySelector && node.querySelector('.custom-all-products, .cap-filter-bar, .cap-product-grid, .cap-card-wrapper'))
              ) {
                scheduleRefresh({ animate: true });
                return;
              }
            }
          }
        });
        mo.observe(root, { childList: true, subtree: true });
      }
    }

    initHomeAjaxAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
